import { THEMES, type ThemeId } from '../hooks/useTheme'

interface Props {
  theme: ThemeId
  onSetTheme: (id: ThemeId) => void
}

export default function ThemePicker({ theme, onSetTheme }: Props) {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-[10px] uppercase tracking-[0.18em] text-ink-50">Theme</span>
      <div className="flex items-center gap-1">
        {THEMES.map(t => {
          const active = t.id === theme
          return (
            <button
              key={t.id}
              onClick={() => onSetTheme(t.id)}
              title={t.description}
              className={`text-[11px] px-2 py-1 rounded border transition-colors ${
                active
                  ? 'bg-saffron-50 text-saffron-500 border-saffron-300'
                  : 'bg-parchment-50 text-ink-100 border-ink-300/10 hover:bg-saffron-50/60 hover:text-saffron-400'
              }`}
              aria-pressed={active}
            >
              {t.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
